import React, { PropTypes } from 'react'
import cn from 'classnames'
import { dateFormatter } from 'lib/helpers'
import i18n from 'lib/i18n'
import styles from './EasinsureClaimsListItem.scss'

const translate = i18n('claimsES')

export const EasinsureClaimsListItem = ({ claimMain, onClaimClicked }) => {
    return (
        <div onClick={onClaimClicked} className={cn('element', styles.claim)}>
            <div>
                <strong>{translate('date')}&#58;</strong>
                <span>{dateFormatter(claimMain.claimDate).toString()}</span>
            </div>
            <div>
                <strong>{translate('creationDate')}&#58;</strong>
                <span>{dateFormatter(claimMain.creationDate).toString()}</span>
            </div>
            <div>
                <strong>{translate('claimNumber')}&#58;</strong>
                <span>{claimMain.claimNumber}</span>
            </div>
            <div>
                <strong>{translate('contractNumber')}&#58;</strong>
                <span>{claimMain.contractNumber}</span>
            </div>
            <div>
                <strong>{translate('qualification')}&#58;</strong>
                <span>{claimMain.qualification}</span>
            </div>
            <div>
                <strong>{translate('status')}&#58;</strong>
                <span>{claimMain.state}</span>
            </div>
        </div>
    )
}
EasinsureClaimsListItem.propTypes = {
    claimMain: PropTypes.object,
    onClaimClicked: PropTypes.func,
}



// WEBPACK FOOTER //
// ./components/easinsure/claims/EasinsureClaimsListItem.jsx